import {
    map, tileLayer, marker, divIcon, icon,
} from 'leaflet';
import 'leaflet/dist/leaflet.css';

// eslint-disable-next-line
import * as L from 'leaflet/dist/leaflet-src.esm';

const makeMap = (mapNode) => {

    const mapNodeId = mapNode.getAttribute('id');
    if (!mapNode) {

        return;

    }

    const latitude = mapNode.getAttribute('data-latitude');
    const longitude = mapNode.getAttribute('data-longitude');
    const mapIcon = mapNode.getAttribute('data-map-icon');
    const iconJson = JSON.parse(mapNode.getAttribute('data-icon'));
    const iconSvg = iconJson.svg;

    const ListingMap = map(mapNodeId, {
        center: [latitude, longitude],
        zoom: 10,
        attributionControl: false,
        scrollWheelZoom: false,
    });
    tileLayer(
        'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=' + mapNode.getAttribute('data-token'),
        {
            attribution: '© <a href="https://www.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
            tileSize: 512,
            zoomOffset: -1,
            maxZoom: 18,
            id: 'mapbox/streets-v11',
        },
    ).addTo(ListingMap);

    let customIcon;
    if (iconSvg) {

        const iconOptions = {
            iconSize: [48, 48],
            iconAnchor: [18, 30],
            popupAnchor: [0, -30],
            className: 'listing-map-icon-wrapper',
            html: `<div>${iconSvg}</div>`,
        };
        customIcon = divIcon(iconOptions);

    } else {

        const iconOptions = {
            iconSize: [48, 48],
            iconAnchor: [18, 30],
            popupAnchor: [0, -30],
            className: 'listing-map-icon-wrapper',
            iconUrl: mapIcon,
        };
        customIcon = icon(iconOptions);

    }

    // eslint-disable-next-line
    const maker = marker([latitude, longitude], {
        icon: customIcon,
    }).addTo(ListingMap);

};

const backButton = () => {

    const buttons = document.querySelectorAll('.d-goto-history');
    for (const button of buttons) {

        button.addEventListener('click', (e) => {

            e.preventDefault();
            window.history.go(-1);
            return false;

        });

    }

};

const mapClass = 'js-listing-map';
const mapNodes = document.getElementsByClassName(mapClass);
if (mapNodes && mapNodes.length) {

    window.addEventListener('load', () => {

        for (let i = 0; i < mapNodes.length; i++) {

            makeMap(mapNodes[i]);

        }

    });
    backButton();

}
